export const dotColor = (score) =>
  score == null ? 'var(--text-tertiary)' :
  score >= 90 ? 'var(--score-green)' :
  score >= 80 ? 'var(--score-amber)' : 'var(--score-red)';
